import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
import SalaryType from '../../../../components/modules/hr/salary-type';
import SalaryTypeMiddleware from '../../../../middleware/modules/hr/salary-type';
import { Helmet } from 'react-helmet';
import i18n from '../../../../i18n';
// middlewares
 

const mapStateToProps = ({ auth,salaryType }) => ({
  isProcessing: salaryType.isProcessing,
  isError: salaryType.isError,
  errorMessage: salaryType.errorMessage,
  datalist:salaryType.data,
  showModal:salaryType.showModal
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    create: () =>SalaryTypeMiddleware.create(),
    reset: () =>SalaryTypeMiddleware.resetList(),
    search: data =>SalaryTypeMiddleware.list(data),
    update: data =>SalaryTypeMiddleware.update(data),
    delete: (id,search) =>SalaryTypeMiddleware.beforeDelete(id,search),
  }, dispatch);
};
class SalaryTypeContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  }

  constructor(props){
    super(props)
    this.deleteItem=this.deleteItem.bind(this);
    this.createItem=this.createItem.bind(this);
    this.updateItem=this.updateItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
   this.props.search(search);
  
  }

  deleteItem(id,search){
    this.props.delete(id,search)
  }
  updateItem(id){
    this.props.update(id)
  }
  createItem(){
    this.props.create()
  }
  render() {
    const {isProcessing, search , datalist,showModal} = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Salary Type List")}
          </title>
        </Helmet>
      <SalaryType
        search={search}
        data={datalist}
        isProcessing={isProcessing}
        showModal={showModal}
        deleteItem={this.deleteItem}
        updateItem={this.updateItem}
        createData={this.createItem}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SalaryTypeContainer);
